import * as _ from 'lodash';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';

import { UnconformityModalComponent } from '../../question-group/question/question-form-modal/unconformity-modal/unconformity-modal.component';

@Component({
	styles: [''],
	selector: 'app-inspection-plan-modal',
	templateUrl: './inspection-plan-modal.component.html',
})
export class InspectionPlanModalComponent implements OnInit {
	@ViewChild(UnconformityModalComponent) unconformityModal: UnconformityModalComponent;
	@Output() inspection = new EventEmitter();
	@Input() inspectionPlanOptions: any[];
	@Input() inspectionPlanId: number;
	@Input() unconformities: any[];

	@Input() keep_status: number = 0;
	@Input() weight: number = 0;
	@Input() verify: number = 0;

	display: boolean;

	constructor() {}

	ngOnInit() {}

	saveInspectionPlan() {
		this.inspection.emit({
			weight: this.weight,
			verify: this.verify,
			keep_status: this.keep_status,

			unc: this.unconformities,
			id: this.inspectionPlanId,
		});

		this.close();
	}

	close() {
		this.display = false;
	}

	openUnconformityModal() {
		this.unconformityModal.display = true;
		this.unconformityModal.onOpenModal(this.unconformities);
	}

	saveInspectionUnconformities(newUnconformities) {
		this.unconformities = newUnconformities || [];
		this.unconformityModal.display = false;

		this.saveInspectionPlan();
	}

	onOpenModal() {
		// do nothing
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/inspection-plan-form/inspection-plan-modal/inspection-plan-modal.component.ts